(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1656],{

/***/ 64663:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/journal/articles/[uid]",
      function () {
        return __webpack_require__(54976);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _imports_universal_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11301);
/* harmony import */ var _components_Abstracts_SliceManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70820);
/* harmony import */ var _components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68971);
/* harmony import */ var _components_Slices_TwoColumnsLayoutLine__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73577);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28443);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);









function BlogArticlePage(_param) {
    var slices = _param.slices, hero = _param.hero, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "slices",
        "hero"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().BlogArticlePage),
                children: [
                    hero && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Slices_TwoColumnsLayoutLine__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, hero), {
                        isHero: true
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_SliceManager__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        mapSliceTypeToComponent: _imports_universal_page__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                        slicesData: slices
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .PageViewAnalytics */ .W, {
                template: "blog"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogArticlePage);


/***/ }),

/***/ 28443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BlogArticlePage":"styles_BlogArticlePage___hnjU","BlogListPage":"styles_BlogListPage__PP5Qp","stickyNav":"styles_stickyNav__YABd_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,3310,4213,2873,3816,5750,6169,1281,4515,5231,423,9774,2888,179], function() { return __webpack_exec__(64663); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);